<!-- vue-quill-editor富文本编辑器 -->
<template>
	<div class="edit_container">
		<p class="newsBread">
			<span>新闻列表</span>
			>
			<span>新闻详情</span>
		</p>
		<el-row class="newsOne">
			<el-col :span="2">新闻类型：</el-col>
			<el-col :span="10">
				<el-select v-model="id" placeholder="请选择"><el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option></el-select>
			</el-col>
			<el-col :span="2">新闻标题：</el-col>
			<el-col :span="10"><el-input v-model="titleInput" placeholder="请输入新闻标题"></el-input></el-col>
		</el-row>
		<el-row class="newsTwo">
			<el-col :span="2">新闻封面：</el-col>
			<el-col :span="22">
				<el-upload
					class="avatar-uploader"
					:http-request="upLoad"
					action="aaa"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload"
				>
					<img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-col>
		</el-row>
		<div id="quillEditorId">
			<el-upload class="avatarUploader" action="aaa" :http-request="quillLoad" :show-file-list="false" list-type="picture-card">
				<i id="quillId" class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<quill-editor id="myQuillEditorId" ref="myQuillEditor"  v-model="editeContent"  :options="editorOption" @change="handelEditorChange($event)"></quill-editor>
		</div>
		<p class="preser"><el-button type="primary" @click="saveHtml">保存</el-button></p>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], //引用、代码块儿
	[{ header: 1 }, { header: 2 }], //标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], //列表
	[{ script: 'sub' }, { script: 'super' }], //上下标
	[{ indent: '-1' }, { indent: '+1' }], //缩进
	[{ direction: 'rtl' }], //文本方向
	[{ size: ['small', false, 'large', 'huge'] }], //字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
	[{ color: [] }, { background: [] }], //字体颜色，字体背景颜色
	[{ font: [] }], //字体
	[{ align: [] }], //对齐方式
	['clean'], //清除字体样式
	['image'] //上传图片、上传视频(video)、超链接(link)
];
export default {
	components: { quillEditor },
	data() {
		return {
			titleInput: '',
			options: [],
			id: '',
			dialogImageUrl: '',
			newsImageUrl: '',
			dialogVisible: false,
			editeContent: `<p></p>
			<p></p>`,
			editorOption: {
				modules: {
					clipboard: {
						// 粘贴版，处理粘贴时候的自带样式
						matchers: [[Node.ELEMENT_NODE, this.HandleCustomMatcher]]
					},
					toolbar: {
						container: toolbarOptions, // 工具栏
						handlers: {
							image: function(value) {
								if (value) {
									// 获取隐藏的上传图片的class，不一定是.el-icon-plus。触发上传图片事件
									document.querySelector('#quillId').click();
								} else {
									this.quill.format('image', false);
								}
							}
						}
					}
				},
				placeholder: ''
			}
		};
	},

	mounted() {
		this.getType();
		this.getDetail();
	},
	methods: {
		getDetail() {
			// let that = this;
			// let quill = this.$refs.myQuillEditor.quill;
			this.$post('newslist/detail?id=' + this.$route.query.id).then(res => {
				this.editeContent = res.data.data.content;
				// this.dialogVisible = true;
				this.dialogImageUrl = res.data.data.coverl;
				this.titleInput = res.data.data.title;
				this.id = res.data.data.tId;
			});
		},
		getType() {
			this.$get('type/list').then(res => {
				this.options = res.list;
			});
		},
		upLoad(file) {
			const formData = new FormData();
			formData.append('file', file.file);
			formData.append('path', 'news');
			this.$post('/file/upload', formData)
				.then(res => res.data)
				.then(data => {
					if (data.code == 0) {
						this.$message({
							message: data.message,
							type: 'success'
						});
						this.dialogImageUrl = this.$Url + data.data;
					}
				});
		},
		handleAvatarSuccess(res, file) {
			this.imageUrl = URL.createObjectURL(file.raw);
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg/png';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
			}
			return isJPG && isLt2M;
		},

		saveHtml() {
			var that = this;
			if (that.id == '') {
				return that.$message({
					message: '请选择新闻类型！'
				});
			} else if (that.titleInput == '') {
				return that.$message({
					message: '请输入新闻标题！'
				});
			} else if (that.dialogImageUrl == '') {
				return that.$message({
					message: '请选择新闻封面！'
				});
			} else if (that.content == '<p></p><p></p>') {
				return that.$message({
					message: '请输入内容！'
				});
			}
			let data = new FormData();
			data.append('id', this.$route.query.id);
			data.append('tId', this.id);
			data.append('title', this.titleInput);
			data.append('coverl', this.dialogImageUrl);
			data.append('content', this.editeContent);

			this.$post('newslist/save', data).then(res => {
				// if (res.message == '添加成功') {
				// 	that.$message({
				// 		message: res.message,
				// 		type: 'success',
				// 		duration:1000
				// 	});
				// 	setTimeout(function(){
				// 		that.id="",
				// 		that.titleInput="",
				// 		that.$refs.upload.clearFiles(),//清空图片
				// 		that.content=`<p></p><p></p>`
				// 	},1000)

				// }
			});
		},
		quillLoad(data) {
			// 思路：上传图片至服务后，拿到返回的图片地址。直接创建image标签插入光标所在的位置
			// 图片上传服务(本地服务或者阿里云服务)
			// 获取富文本组件实例
			const formData = new FormData();
			formData.append('file', data.file);
			formData.append('path', 'news');
			this.$post('/file/upload', formData)
				.then(res => res.data)
				.then(data => {
					if (data.code == 0) {
						this.newsImageUrl = this.$Url + data.data;
						let quill = this.$refs.myQuillEditor.quill;
						// 上传服务成功后，按根据光标位置把图片插入编辑器中
						if (this.newsImageUrl) {
							// 获取光标所在位置,data.url表示上传服务后返回的图片地址
							let length = quill.getSelection().index;
							// 插入图片，data.url为服务返回的图片链接地址
							quill.insertEmbed(length, 'image', this.newsImageUrl);
							// 调整光标到最后
							quill.setSelection(length + 1);
						} else {
							this.$message.closeAll();
							this.$message.error('图片插入失败');
						}
					}
				});
		},
		//富文本内容
		handelEditorChange(el) {
			// this.editeContent=el
			// window.console.log(this.editeContent)
		},
		HandleCustomMatcher(node, Delta) {
			
			return Delta;
		}
	}
};
</script>
<style>
#quillEditorId .avatarUploader {
	display: none;
}
/*  注意如何修改组件自带的样式不能加 scoped="scoped" */
.edit_container {
	height: 400px;
}
.ql-container.ql-snow {
	height: 200px !important;
}
.edit_container .newsBread {
	font-size: 14px;
	margin: 16px 0;
}
.edit_container .newsBread > span:nth-of-type(2) {
	color: #409eff;
}
.edit_container .el-row .el-col{
	font-size:16px;
}
.edit_container .preser {
	text-align: center;
	margin-top: 20px;
}
.edit_container .newsOne {
	height: 50px;
	padding: 5px;
	line-height: 38px !important;
}
.edit_container .newsOne:first-of-type,
.edit_container .newsOne:nth-of-type(3) {
	text-align: center;
}
.edit_container .newsTwo {
	padding: 5px;
}
.edit_container .newsTwo > .el-col:first-of-type {
	text-align: center;
}
.edit_container .el-select {
	width: 100%;
}
.edit_content {
	height: 80%;
	margin-top: 10px;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.disabled .el-upload--picture-card {
	display: none;
}
</style>
